import InProgressActivitiesByResponsibleStackedColumnChart from "./InProgressActivitiesByResponsibleStackedColumnChart";

export { InProgressActivitiesByResponsibleStackedColumnChart };
